import { Reveal } from "./Reveal";

const IMG =
  "https://static.prod-images.emergentagent.com/jobs/6993066b-ff7c-42b2-b892-e8aa9d739ad3/images/efa1bead25c2c8f791ae0507ad3c40885cb011c15eab0638ef6987f741e5344b.png";

const REGIONS = [
  { region: "United States", partners: "athenahealth provider network · Corporate Wellness clients" },
  { region: "India", partners: "Healthy Plus India Pvt. Ltd. · Hospital partnerships in development" },
  { region: "Provider Networks", partners: "Integrated risk reports delivered to in-network MDs" },
  { region: "Insurance Carriers", partners: "Aligned incentives · risk mitigated · cost contained" },
  { region: "Corporate Employers", partners: "Nurse-level Health Coaches · insured & uninsured programs" },
  { region: "Recognition", partners: "Industry Tech Outlook · Shortlister · PR Newswire" },
];

export const Partnerships = () => {
  return (
    <section
      data-testid="partnerships-section"
      className="relative py-24 lg:py-32 bg-white overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-20 items-start">
          <Reveal className="lg:col-span-6">
            <div className="flex items-center gap-4 mb-6">
              <span className="h-px w-10 bg-[#0A192F]/40" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60">
                Global Partnerships
              </span>
            </div>
            <h2 className="font-serif text-4xl sm:text-5xl lg:text-[64px] leading-[1.02] tracking-tight text-[#0A192F]">
              A network built
              <br />
              ministry by ministry.
            </h2>
            <p className="mt-10 text-lg text-[#475569] leading-relaxed max-w-xl">
              Sean's work spans six continents and the full provider stack — from
              sovereign health authorities defining national digital strategy to
              the community clinics delivering it on the last mile.
            </p>

            <div className="mt-10 relative h-64 lg:h-80 overflow-hidden border border-black/5 bg-[#F8FAFC]">
              <img
                src={IMG}
                alt="Global partnerships map"
                className="w-full h-full object-cover opacity-95"
                loading="lazy"
              />
            </div>
          </Reveal>

          <Reveal delay={150} className="lg:col-span-6">
            <div className="grid sm:grid-cols-2 gap-x-8">
              {REGIONS.map((r, i) => (
                <div
                  key={r.region}
                  className={`py-6 ${i < REGIONS.length - 2 ? "border-b border-[#0A192F]/10" : ""}`}
                >
                  <div className="text-[10px] uppercase tracking-[0.3em] text-[#0A192F]/60">
                    Region
                  </div>
                  <h3 className="mt-2 font-serif text-2xl text-[#0A192F]">
                    {r.region}
                  </h3>
                  <p className="mt-2 text-sm text-[#475569] leading-relaxed">
                    {r.partners}
                  </p>
                </div>
              ))}
            </div>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
